import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRoller: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="roller, scooter"><path d="M13.75 4C13.3358 4 13 4.33579 13 4.75C13 5.16421 13.3358 5.5 13.75 5.5H15.4011L17.1633 13.2643C16.1174 13.6969 15.3269 14.6217 15.0805 15.75H8.91946C8.57612 14.1774 7.17556 13 5.5 13C3.567 13 2 14.567 2 16.5C2 18.433 3.567 20 5.5 20C7.17556 20 8.57612 18.8226 8.91946 17.25H15.0805C15.4239 18.8226 16.8244 20 18.5 20C20.433 20 22 18.433 22 16.5C22 14.6146 20.5092 13.0774 18.6421 13.0028L16.7314 4.58401C16.6539 4.24243 16.3503 4 16 4H13.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconRoller;
